
// Simulated pending alerts data
const mockAlerts = [
  {
    id: 1,
    type: 'expiry',
    title: 'Items Nearing Expiry',
    description: 'Product SKU-001 expires in 7 days',
    itemCode: 'SKU-001',
    itemName: 'Organic Milk 1L',
    quantity: 150,
    expiryDate: '2025-12-12',
    status: 'pending',
    recipients: [],
    scheduledDate: null,
    scheduledTime: null,
  },
  {
    id: 2,
    type: 'expiry',
    title: 'Items Nearing Expiry',
    description: 'Product SKU-045 expires in 3 days',
    itemCode: 'SKU-045',
    itemName: 'Fresh Yogurt 500g',
    quantity: 80,
    expiryDate: '2025-12-08',
    status: 'pending',
    recipients: ['warehouse@company.com'],
    scheduledDate: null,
    scheduledTime: null,
  },
  {
    id: 3,
    type: 'sync',
    title: 'Quantity Not Synced',
    description: 'Inventory mismatch detected for SKU-102',
    itemCode: 'SKU-102',
    itemName: 'Steel Bolts M8',
    systemQty: 500,
    physicalQty: 485,
    variance: -15,
    status: 'pending',
    recipients: [],
    scheduledDate: null,
    scheduledTime: null,
  },
  {
    id: 4,
    type: 'sync',
    title: 'Quantity Not Synced',
    description: 'Stock count variance for SKU-203',
    itemCode: 'SKU-203',
    itemName: 'Copper Wire 2.5mm',
    systemQty: 1000,
    physicalQty: 1050,
    variance: 50,
    status: 'pending',
    recipients: [],
    scheduledDate: null,
    scheduledTime: null,
  },
  {
    id: 5,
    type: 'po',
    title: 'Pending Purchase Order',
    description: 'PO-2025-0891 awaiting approval',
    poNumber: 'PO-2025-0891',
    supplier: 'ABC Suppliers Ltd',
    totalItems: 25,
    totalValue: 15750.00,
    createdDate: '2025-12-01',
    status: 'pending',
    recipients: ['procurement@company.com'],
    scheduledDate: null,
    scheduledTime: null,
  },
  {
    id: 6,   
    type: 'po',
    title: 'Pending Purchase Order',
    description: 'PO-2025-0892 requires review',
    poNumber: 'PO-2025-0892',
    supplier: 'XYZ Manufacturing',
    totalItems: 12,
    totalValue: 8900.00,
    createdDate: '2025-12-03',
    status: 'pending',
    recipients: [],
    scheduledDate: null,
    scheduledTime: null,
  },
  {
    id: 7,
    type: 'so',
    title: 'Pending Sales Order',
    description: 'SO-2025-1456 ready for dispatch',
    soNumber: 'SO-2025-1456',
    customer: 'Metro Retail Inc',
    totalItems: 45,
    totalValue: 23400.00,
    orderDate: '2025-12-02',
    status: 'pending',
    recipients: [],
    scheduledDate: null,
    scheduledTime: null,
  },
  {
    id: 8,
    type: 'so',
    title: 'Pending Sales Order',
    description: 'SO-2025-1457 pending shipment',
    soNumber: 'SO-2025-1457',
    customer: 'Global Distributors',
    totalItems: 78,
    totalValue: 45600.00,
    orderDate: '2025-12-04',
    status: 'pending',
    recipients: ['sales@company.com', 'logistics@company.com'],
    scheduledDate: null,
    scheduledTime: null,
  },
];

// Simulate API delay
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

// Fetch all pending alerts
export const fetchPendingAlerts = async () => {
  await delay(300);
  const pendingAlerts = mockAlerts.filter(alert => alert.status === 'pending');
  console.log('Fetched alerts:', pendingAlerts.length);
  return {
    success: true,
    data: pendingAlerts,
    total: pendingAlerts.length,
  };
};

// Update alert with recipients and schedule
export const updateAlert = async (alertId, updateData) => {
  await delay(500);
  const alertIndex = mockAlerts.findIndex(a => a.id === alertId);
  if (alertIndex !== -1) {
    mockAlerts[alertIndex] = {
      ...mockAlerts[alertIndex],
      ...updateData,
      status: 'scheduled',
    };
    return {
      success: true,
      message: 'Alert updated successfully',
      data: mockAlerts[alertIndex],
    };
  }
  return {
    success: false,
    message: 'Alert not found',
  };
};

// Delete/dismiss alert
export const dismissAlert = async (alertId) => {
  await delay(300);
  const alertIndex = mockAlerts.findIndex(a => a.id === alertId);
  if (alertIndex !== -1) {
    mockAlerts[alertIndex].status = 'dismissed';
    return {
      success: true,
      message: 'Alert dismissed',
    };
  }
  return {
    success: false,
    message: 'Alert not found',
  };
};
